import * as yup from 'yup';

export const overviewFiltersValidationSchema = yup.object().shape({
  initialDateFrom: yup.string(),
  initialDateTo: yup.string(),
});
